import React from 'react'
import styled from 'styled-components'
import { Delete } from 'media/icons'
import { Add } from 'media/icons'

const Overlay = styled.div`
	position: absolute;
  width: 100%;
  height: 100%;
	background-color: rgba(0, 0, 0, 0.4);
`

const PriceLabel = styled.div`
	z-index: 1;
	min-height: ${({ hasImg }) => hasImg ? 25 : 30}px;
	background-color: #fff;
	display: flex;
	text-align: center;
	justify-content: center;
	flex-wrap: wrap;
	flex-direction: column;
	width: 100%;
	position: relative;
	&:before {
		content: '';
	  width: 40px;
	  height: 1px;
	  background: rgba(205, 205, 205, 0.5);
	  position: absolute;
	  top: 0px;
	  left: 50%;
	  transform: translate(-50%, 0);
	}
`

const ProductLabel = styled.div`
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	flex-direction: column;
	padding: 0 3px;
	width: 100%;
	height: 100%;
	div {
		padding: 0 2px;
		width: 100%;
		max-height: 2.3em;
		overflow: hidden;
		text-align: center;
	}
`

const StyledCell = styled.div`
	height: 112px;
	width: 112px;
	cursor: pointer;
	position: relative;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	display: flex;
	border-radius: 3px;
	box-shadow: 0 2px 2px 0 rgba(90, 90, 90, 0.12);
	background: ${({ src }) => src ? `url(${src})` : `#fff` };
	background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
	border: ${({ borderColor }) => `solid 2px ${borderColor || '#cdcdcd'}`};
	margin: 0 10px 10px 0;
	font-size: 11px;
	${ProductLabel} {
		color: ${({ src }) => src ? '#fff' : null}
	}
	svg:first-child {
		margin: 20px 0;
		width: 35px;
		height: 35px;
		path { fill: #fff; }
		circle { fill: #cdcdcd; fill-opacity: 1; stroke: #cdcdcd; }
	}
	svg:not(:first-child) {
		margin: 0;
		cursor: pointer;
		font-size: 15px;
		position: absolute;
		top: -7.5px;
		right: -7.5px;
		float: right;
		z-index: 2;
		path {
			fill: #cdcdcd;
		}
		circle {
			fill: #fff;
			stroke: #cdcdcd;
		}
		&:hover {
			path {
				fill: ${({ theme }) => theme.primaryColor};
			}
			circle {
				stroke: ${({ theme }) => theme.primaryColor};
			}
		}
	}
`

const Cell = ({ onClick, src, code, currency, price, name, borderColor, onRemove, dropTargetRef, noData }) => {
	const hasImg = !!src
	return(
		<StyledCell ref={dropTargetRef} borderColor={borderColor} src={src} onClick={onClick}>
			{noData ?
				<Add/> :
				<>
					{hasImg && <Overlay/>}
					<ProductLabel>
						<div>{code}</div>
						<div>{name}</div>
					</ProductLabel>
					<PriceLabel hasImg={hasImg}>{currency} {price}</PriceLabel>
					{onRemove && <Delete onClick={onRemove}/>}
				</>
			}
		</StyledCell>
	)
}
export default Cell
